export type Tema = 'auto' | 'claro' | 'oscuro';
const CLAVE = 'laser-admin-tema';

export function leerTema(): Tema {
  try {
    const v = localStorage.getItem(CLAVE);
    return v === 'claro' || v === 'oscuro' ? v : 'auto';
  } catch {
    return 'auto';
  }
}

export function aplicarTema(t: Tema) {
  const raiz = document.documentElement;
  if (t === 'auto') raiz.removeAttribute('data-theme');
  else raiz.setAttribute('data-theme', t === 'oscuro' ? 'dark' : 'light');
  try { localStorage.setItem(CLAVE, t); } catch { /* sin almacenamiento */ }
}

export const siguienteTema = (t: Tema): Tema => (t === 'auto' ? 'oscuro' : t === 'oscuro' ? 'claro' : 'auto');
export const ETIQUETA_TEMA: Record<Tema, string> = { auto: 'Tema: automático', oscuro: 'Tema: oscuro', claro: 'Tema: claro' };
